// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root___tITk","label":"Labeled_label__2NUj8","divider":"Labeled_divider__2R-Cs"};